export const SET_USER = `SET_USER`;

export const SET_CART_ITEMS = `SET_CART_ITEMS`;
export const SET_MY_CART_MODAL_VISIBILITY = `SET_MY_CART_MODAL_VISIBILITY`;

export const SET_SIDE_BAR_VISIBILITY = `SET_SIDE_BAR_VISIBILITY`;
